// extracted by mini-css-extract-plugin
module.exports = {"select-c":"select-c-151c0272","selectC":"select-c-151c0272"};